import { Records } from 'core/anand.records';
import { populateViewTileHelper } from 'helpers/RecordsHelper';
import React from 'react';
import { connect } from 'react-redux';
import { AnumatiRecord, ApplicationState } from 'types';

export const anumatiViewTileCSS = `
<style>
	.checkins-btn {
		display: none;
	}

	.intl-tel-input {
		width: 100%;
	}

	.heading {
		text-align: center;
		font-size: 1.2em;
		font-weight: bold;
		margin-bottom: 1.5em;
		border-bottom: 1px solid grey;
		padding-bottom: 0.3em;
		text-transform: uppercase;
	}

	.tile .comments {
		border: 1px solid darkgray;
		padding: 10px;
		overflow: auto;
		max-height: 6em;
	}

	.tile .comments-title {
		border: 1px solid darkgray;
		border-bottom: 0;
		text-align: center;
	}

	.tt-suggestion:hover {
		color: white;
		background-color: #0097cf;
		cursor: pointer;
	}

	.through-sugestion {
		padding: 0.7em 2em;
		white-space: nowrap;
	}

	.tt-menu {
		width: auto;
		overflow-y: auto;
		max-height: 150px;
		box-shadow: 1px 1px 5px 1px grey;
		background-color: white;
		overflow-x: hidden;
	}

	input[name='subscriber_no_code'] {
		text-transform: uppercase;
	}

	.tile.anumati-record.detail {
		padding-top: 15px;
	}

	.tile.anumati-record .main-details {
		padding-right: 30px;
	}

	.tile.anumati-record .main-details .title {
		text-align: right;
		padding: 0;
		margin-bottom: 15px;
		font-weight: bold;
		font-size: 0.9em;
	}

	.tile.anumati-record .main-details .value {
		padding-right: 0;
		margin-bottom: 15px;
	}

	.tile.anumati-record input {
		width: 100%;
		background-color: white !important;
		border: none;
		border-bottom: 1px solid darkgray;
	}

	.tile.anumati-record input:disabled {
		background-color: #ccc !important;
	}

	.tile.anumati-record input[type='checkbox'] {
		width: auto;
		margin-right: 5px;
	}

	.radio,
	.checkbox {
		margin-top: 0;
		margin-bottom: 0;
	}

	.tile.anumati-record input:focus {
		outline: none;
	}

	.tile.anumati-record .value select {
		width: 100%;
	}

	.tile.anumati-record .language-value {
		text-transform: capitalize;
	}

	.edit-allowed .check-in-details {
		display: none;
	}

	.bootstrap-dialog-message .edit-allowed .check-in-details {
		display: block;
	}

	form.tile.anumati-record .address {
		width: 100%;
		resize: none;
		height: 6em;
	}

	.tile.anumati-record .address {
		border: 1px solid darkgray;
		padding: 10px;
		overflow: auto;
		max-height: 6em;
	}

	.tile.anumati-record .comments-title {
		border: 1px solid darkgray;
		border-bottom: 0;
		text-align: center;
	}

	div.tile.anumati-record .main-details .value {
		border-bottom: 1px solid lightgrey;
		min-height: 1.5em;
		padding-right: 0;
	}

	.lb {
		border-bottom: 1px solid lightgrey;
	}

	.multi-field-row {
		padding-top: 3px;
		padding-bottom: 3px;
		font-size: 14px;
	}

	.multi-field-row:nth-last-child(1) {
		border-bottom: none;
	}

	.btn-danger, .btn-warning {
		float: left;
	}

	table {
		width: 100%;
		font-size: 0.9em;
		max-height: 12em;
	}

	table,
	th,
	td {
		border: 1px solid black;
		padding: 3px;
		text-align: center;
	}

	thead {
		text-align: center;
		font-weight: bold;
	}

	.reference-suggestion img {
		width: 100%;
		padding: 0 5px;
	}

	.tt-dropdown-menu {
		top: auto !important;
		bottom: 100% !important;
	}

	.tt-dropdown-menu-name {
		top: 100% !important;
		bottom: auto !important;
	}

	.tile.anumati-record .record-id {
		top: 30px;
	}

	.tile.anumati-record .tile-view-toggle-btn {
		position: absolute;
		top: 2px;
		right: 2px;
		z-index: 2;
		padding: 4px 7px;
		background: transparent;
		border: none;
		outline: none;
		color: #337ab7;
		line-height: 1;
		cursor: pointer;
	}

	.tile.anumati-record .tile-view-toggle-btn:active {
		color: #23527c;
	}

	.tile.anumati-record .tile-pin-btn {
		position: absolute;
		top: 2px;
		right: 32px;
		z-index: 2;
		padding: 4px 7px;
		background: transparent;
		border: none;
		outline: none;
		color: #999;
		line-height: 1;
		cursor: pointer;
	}

	.tile.anumati-record .tile-pin-btn.pinned {
		color: #4cae4c;
	}

	.tile.anumati-record.pinned-tile {
		border-color: #4cae4c;
		border-width: 2px;
	}

	.tile.anumati-record .record-share-button.shared,
	.tile.anumati-record .record-share-button.shared:hover,
	.tile.anumati-record .record-share-button.shared:focus,
	.tile.anumati-record .record-share-button.shared:active {
		color: #fff;
		background-color: #5cb85c;
		border-color: #4cae4c;
		/* The bootstrap theme gives buttons a gradient and shifts it on hover, which would
		   expose this background colour as a band along the bottom edge. */
		background-image: none;
	}

	.tile.anumati-record .record-share-button[disabled] {
		opacity: 0.6;
	}

	.tile.anumati-record .record-share-button .glyphicon {
		margin-left: 6px;
	}

	.record-sms-button, .record-ams-button, .record-print-button, .record-copy-button {
		float: right;
		margin-left: 6px;
	}

	.tile .deleted {
		display: none;
		color: red;
	}

	@media (max-width: 991px) {
		.check-in-details {
			display: none;
		}
	}
</style>
`;

const html = `
<div id="anumati-detail-record" class="tile anumati-record detail edit-allowed">
	<button type="button" class="tile-pin-btn" title="Pin this tile" aria-label="Pin this tile">
		<span class="glyphicon glyphicon-pushpin"></span>
	</button>
	<button type="button" class="tile-view-toggle-btn" title="Collapse this tile" aria-label="Collapse this tile">
		<span class="glyphicon glyphicon-resize-small"></span>
	</button>
	<div class="record-id">
		<span></span>
	</div>
	<div class="row">
		<div class="col-xs-12 main-details">
			<div class="block">
				<div class="title col-xs-3">
					Card No:
				</div>
				<div class="value card-detail col-xs-9">
				</div>
				<div class="title col-xs-3">
					Name:
				</div>
				<div class="value self-detail col-xs-9">
				</div>
				<div class="title col-xs-3">
					Count:
				</div>
				<div class="value count-detail col-xs-9">
				</div>
				<div class="title col-xs-3">
					Date:
				</div>
				<div class="value date-detail col-xs-9">
				</div>
				<div class="title col-xs-3">
					Ref:
				</div>
				<div class="value ref-detail col-xs-9">
				</div>
				<div class="title col-xs-3">
					Mobile:
				</div>
				<div class="value phone-detail col-xs-9">
				</div>
				<div class="title col-xs-3">
					Created By:
				</div>
				<div class="value created-by-detail col-xs-9">
				</div>
				<div class="deleted">
					<div class="title col-xs-3">
						Deleted:
					</div>
					<div class="value deleted-detail col-xs-9">
					</div>
				</div>
				<div class="publish">
					<div class="title col-xs-3">
						Publish Time:
					</div>
					<div class="value publish-time-detail col-xs-9">
					</div>
				</div>
				<div class="expiry">
					<div class="title col-xs-3">
						Expire Time:
					</div>
					<div class="value expire-time-detail col-xs-9">
					</div>
				</div>
			</div>
			<button class="btn-primary btn record-approve-button">Apporve</button>
			<button class="btn-primary btn record-print-button">Print</button>
			<button class="btn-primary btn record-ams-button">Send AMS</button>
			<button class="btn-primary btn record-copy-button">Copy</button>
			<button type="button" class="btn-primary btn record-share-button">Share</button>
		</div>
	</div>
	<div class="row check-in-details">
		<div class='col-xs-12'>
			<div class='heading'>Check-In Details</div>
		</div>
		<div class="check-in-info">
			<div class="col-xs-12 main-details">
				<div class="block">
					<div class="row check-in-detail">
						<div id="check-in-data-detail" class="multi-field-row hidden col-xs-12">
							<div class="row">
								<div class="title inout col-xs-1">
								</div>
								<div class="date col-xs-3">
									<input type="text" class="value" disabled value="" placeholder="Date"/>												
								</div>
								<div class="title col-xs-1">
									Name:
								</div>
								<div class="value name col-xs-2">
								</div>
								<div class="title col-xs-1">
									Count:
								</div>
								<div class="value count col-xs-1">
								</div>
								<div class="title col-xs-1">
									Mobile:
								</div>
								<div class="value phone col-xs-2">
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<button class="btn-primary btn checkins-btn">Check-In/Out</button>
</div>
`;

let briefHtml = `
<div id="anumati-brief-record" class="row tile anumati-record brief">
	<button type="button" class="tile-pin-btn" title="Pin this tile" aria-label="Pin this tile">
		<span class="glyphicon glyphicon-pushpin"></span>
	</button>
	<button type="button" class="tile-view-toggle-btn" title="Expand this tile" aria-label="Expand this tile">
		<span class="glyphicon glyphicon-resize-full"></span>
	</button>
	<div class="record-id">
		<span></span>
	</div>
	<div class="col-xs-12 main-details">
		<div class="block">
			<div class="title col-xs-2">
				Card No:
			</div>
			<div class="value card-detail col-xs-10">
			</div>
			<div class="title col-xs-2">
				Name:
			</div>
			<div class="value self-detail col-xs-10">
			</div>
		</div>
	</div>
</div>
`;

interface Props {
	record?: AnumatiRecord;
	index?: number;
	listRef?: React.RefObject<any>;
	showDetailed?: boolean;
	tileOverrides?: { [id: string]: boolean };
	onToggleTileDetailed?: (recordId: string) => void;
	pinnedTiles?: { [id: string]: boolean };
	onTogglePinnedTile?: (recordId: string) => void;
}

class Component extends React.PureComponent<Props> {
	private tileRef = React.createRef<HTMLDivElement>();

	private recordId() {
		return (this.props.record as any)?.id;
	}

	/** A per tile choice wins over the global brief/detailed mode. */
	private isDetailed() {
		let { tileOverrides, showDetailed } = this.props;
		let recordId = this.recordId();

		if (recordId && tileOverrides && typeof tileOverrides[recordId] === 'boolean') {
			return tileOverrides[recordId];
		}

		return !!showDetailed;
	}

	private isPinned() {
		let recordId = this.recordId();
		return !!(recordId && this.props.pinnedTiles?.[recordId]);
	}

	private bindTileControls() {
		let tile = $(this.tileRef.current);

		// These are editor conveniences, so read only and check-in only users do not see
		// them. The global Detailed control in the header remains available to everyone.
		if (!Records.editAllowed) {
			tile.find('.tile-view-toggle-btn, .tile-pin-btn').hide();
			return;
		}

		// Namespaced and cleared first so repeated populates cannot stack handlers.
		// The tile itself opens the details dialog on click, hence stopPropagation.
		tile.find('.tile-view-toggle-btn')
			.off('click.tileControls')
			.on('click.tileControls', (event) => {
				event.preventDefault();
				event.stopPropagation();
				this.props.onToggleTileDetailed?.(this.recordId());
			});

		tile.find('.tile-pin-btn')
			.off('click.tileControls')
			.on('click.tileControls', (event) => {
				event.preventDefault();
				event.stopPropagation();
				this.props.onTogglePinnedTile?.(this.recordId());
			});

		let pinned = this.isPinned();
		tile.find('.tile-pin-btn')
			.toggleClass('pinned', pinned)
			.attr('title', pinned ? 'Unpin this tile' : 'Pin this tile')
			.attr('aria-label', pinned ? 'Unpin this tile' : 'Pin this tile');
		tile.find('.tile').toggleClass('pinned-tile', pinned);
	}

	componentDidMount() {
		populateViewTileHelper(this.tileRef, this.props.record, this.props.index, this.props.listRef);
		this.bindTileControls();
	}

	componentDidUpdate(prevProps, prevState) {
		populateViewTileHelper(this.tileRef, this.props.record, this.props.index, this.props.listRef);
		this.bindTileControls();
	}

	render() {
		return <div ref={this.tileRef} dangerouslySetInnerHTML={{ __html: this.isDetailed() ? html : briefHtml }}></div>;
	}
}

function mapStateToProps(state: ApplicationState) {
	return {};
}

export const AnumatiViewTile = connect(mapStateToProps)(Component);
